export default (config) =>
  config[
    "subscriptionUMS/functionalities/automaticReplaceBenefitAfterChangeGP"
  ] === "1" ||
  config[
    "subscription/functionalities/automaticReplaceBenefitAfterChangeGP"
  ] === "1";
